import React, { useMemo } from 'react'
import { useHasRiskCategoryConfiguration } from 'src/context/Gatekeeper'
import { useRisksContext } from 'src/pages/Risks/context/RisksContext'
import { RISK_CATEGORY_LABEL } from 'src/pages/Risks/risks.constants'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

export const RiskCategoryFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => {
  const hasRiskCategoryConfiguration = useHasRiskCategoryConfiguration()
  const {
    categoryOptions,
    isCategoryOptionsInitialized,
    isCategoryOptionsLoading,
  } = useRisksContext()

  const filterValues = useMemo(() => {
    if (hasRiskCategoryConfiguration) {
      return [...categoryOptions]
        .sort(
          (a, b) =>
            (a.sortOrder ?? a.value) - (b.sortOrder ?? b.value) ||
            a.name.localeCompare(b.name),
        )
        .map((category) => ({
          label: category.name,
          value: String(category.value),
        }))
    }

    return Object.entries(RISK_CATEGORY_LABEL)
      .sort(([a], [b]) => Number(a) - Number(b))
      .map(([value, label]) => ({
        label,
        value,
      }))
  }, [categoryOptions, hasRiskCategoryConfiguration])

  return (
    <FilterDropdown
      filterParam={FilterParam.RISK_CATEGORY}
      filterName={FilterName.RISK_CATEGORY}
      filterValues={filterValues}
      isLoading={
        hasRiskCategoryConfiguration &&
        (isCategoryOptionsLoading || !isCategoryOptionsInitialized)
      }
      isNested={isNested}
    />
  )
}
